import BehaviourBarGraph from "../BehaviourBarGraph.jsx";
import React from "react";
import { formatNumber } from "@signolteam/shared/units-of-measure";

let defaultMetadata = {
  flaps_target_distance_nm: 3.5,
  flaps_deployed_distance: 2.5,
};

export const behaviourMetadataFields = Object.keys(defaultMetadata);
export default function graph({
  bvrColour,
  metadata = defaultMetadata,
  missingDataMsg,
  isExample,
}) {
  //metadata = defaultMetadata;
  let limit = metadata["flaps_target_distance_nm"];
  let actual = metadata["flaps_deployed_distance"];

  if (!limit || !actual) {
    return (
      <div className="relative text-center my-6 mx-auto text-2xl fill-current">
        {missingDataMsg}
      </div>
    );
  }

  limit = Number(limit).toFixed(1);
  actual = Number(actual).toFixed(1);

  const data = [
    {
      name: "Flaps 15 deployed",
      mobileName: `Label 1`,
      beforeThreshold: actual > limit ? limit : actual,
      afterThreshold: actual > limit ? actual - limit : 0,
      underThresholdColour:
        actual > limit ? bvrColour.codes["200"] : bvrColour.codes["500"],
      overThresholdColour: bvrColour.codes["900"],
    },
  ];

  const domainMin = 0;
  const margin = actual < limit ? 0.2 * limit : 0.2 * actual;
  const domainMax =
    actual < limit
      ? Math.ceil(Number(limit) + margin)
      : Math.ceil(Number(actual) + margin);
  const domain = [domainMin, domainMax];

  const mobileMargin = actual < limit ? 0.05 * limit : 0.05 * actual;
  const mobileDomainMax =
    actual < limit
      ? Math.ceil(Number(limit) + mobileMargin)
      : Math.ceil(Number(actual) + mobileMargin);
  const mobileDomain = [domainMin, mobileDomainMax];

  const thresholdLineColour = bvrColour.codes["900"];

  const unitOfMeasure = "NM";

  return (
    <BehaviourBarGraph
      data={data}
      threshold={limit}
      thresholdLabel={`Signol threshold${
        !isExample
          ? ` (${
              formatNumber(limit, {
                unit: unitOfMeasure,
                options: { boundaryValues: [0, actual] },
              }).formattedValue
            })`
          : ""
      }`}
      mobileDomain={mobileDomain}
      domain={domain}
      refLineColour={thresholdLineColour}
      success={actual < limit}
      unitOfMeasure={` ${unitOfMeasure}`}
      axisLabel={`Distance from Runway`}
      hideYLine={true}
      hideNum={true}
      barLabelFormatter={(value) =>
        `${
          formatNumber(value, {
            unit: unitOfMeasure,
            options: { boundaryValues: [0, actual] },
          }).formattedValue
        }`
      }
      isExample={isExample}
    />
  );
}
